import React from "react";
import Header from "../../components/Header";
import { IconButton } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, Flex } from "antd";
import {
  COMPONENT_ERROR_TEXT,
  PROVINCES_LIST,
  subformInputChange,
} from "../../utils";
import TextField from "../../components/TextField";
import Dropdown from "../../components/Dropdown";
import canadaFlag from "../../assets/CanadaFlag.jpg";
import CheckboxAntd from "../../components/CheckboxAntd";

const Branch = ({ data, setData, error, setError }) => {
  const addBranch = () => {
    // let undefined_check_error = error.list_of_branches.some((item) => {
    //   return Object.values(item).some((value) => value === undefined);
    // });

    // if (undefined_check_error) {
    //   // let copy_error = { ...error };

    //   // copy_error.list_of_branches.map((item) => {
    //   //   for (const key in item) {
    //   //     if (item[key] === undefined) {
    //   //       item[key] = true;
    //   //     }
    //   //   }
    //   // });

    //   // setError(copy_error);
    //   return;
    // }

    // let true_check_error = error.list_of_branches.some((item) => {
    //   return Object.values(item).some((value) => value === true);
    // });

    // if (true_check_error) {
    //   return;
    // }

    let key = uuidv4();

    setData({
      ...data,
      list_of_branches: [
        ...data?.list_of_branches,
        {
          key,
          branch_name: "",
          address: "",
          line2: "",
          country: "Canada",
          city: "",
          province: "",
          postal_code: "",
          phone: "",
        },
      ],
    });

    // setError({
    //   ...error,
    //   list_of_branches: [
    //     ...error?.list_of_branches,
    //     {
    //       key,
    //       branch_name: undefined,
    //       address: undefined,
    //       country: false,
    //       city: undefined,
    //       province: undefined,
    //       postal_code: undefined,
    //       phone: undefined,
    //     },
    //   ],
    // });
  };

  return (
    <div>
      <Header text="Branch Details" />

      <div className="form_container">
        <CheckboxAntd
          label="Is the head office a branch?"
          checked={data?.is_ho_the_branch}
          onChange={(e) => {
            const isChecked = e.target.checked;
            setData({ ...data, is_ho_the_branch: isChecked });

            if (isChecked) {
              // Add head office as the first branch
              const headOfficeBranch = {
                key: "head-office",
                branch_name: data?.operating_name || data?.legal_name_of_brokage || "Head Office",
                address: data?.ho_street || "",
                line2: data?.ho_line2 || "",
                country: data?.ho_country || "Canada",
                city: data?.ho_city || "",
                province: data?.ho_province || "",
                postal_code: data?.ho_pc || "",
                phone: data?.ho_phone_number || "",
              };

              // Check if head office branch already exists
              const existingBranches = data?.list_of_branches || [];
              const hasHeadOffice = existingBranches.some(branch => branch.key === "head-office");

              if (!hasHeadOffice) {
                // Add head office as first branch
                setData({
                  ...data,
                  is_ho_the_branch: isChecked,
                  list_of_branches: [headOfficeBranch, ...existingBranches]
                });

                // Add corresponding error object for head office branch
                const headOfficeError = {
                  key: "head-office",
                  branch_name: false,
                  address: false,
                  country: false,
                  city: false,
                  province: false,
                  postal_code: false,
                  phone: false,
                };

                setError({
                  ...error,
                  list_of_branches: [headOfficeError, ...(error?.list_of_branches || [])]
                });
              }
            } else {
              // Remove head office branch when unchecked
              const filteredBranches = (data?.list_of_branches || []).filter(
                branch => branch.key !== "head-office"
              );
              const filteredErrors = (error?.list_of_branches || []).filter(
                err => err.key !== "head-office"
              );

              setData({
                ...data,
                is_ho_the_branch: isChecked,
                list_of_branches: filteredBranches
              });

              setError({
                ...error,
                list_of_branches: filteredErrors
              });
            }
            // if (e.target.checked) {
            //   let error_branch = [...error?.list_of_branches];
            //   error_branch.map((item) => {
            //     for (const key in item) {
            //       item[key] = undefined;
            //     }
            //   });

            //   setError({ ...error, list_of_branches: error_branch });
            // }
          }}
        />
      </div>

      <div className="form_container">
        <Flex gap={32} align="center" className="mb_16">
          <div className="label">List of Branches</div>
        </Flex>

        <Flex vertical gap={32}>
          {data?.list_of_branches.map((item, index) => {
            return (
              <Card
                title={
                  <p>
                    Branch #{index + 1}{" "}
                    {/* {Object.values(error.list_of_branches[index]).some(
                      (value) => value === true
                    ) ? (
                      <span className="subform_error_text">
                        {COMPONENT_ERROR_TEXT}
                      </span>
                    ) : (
                      ""
                    )} */}
                  </p>
                }
                size="small"
                key={index}
                extra={
                  <IconButton
                    onClick={() => {
                      let filter = data?.list_of_branches.filter(
                        (i) => item?.key !== i?.key
                      );

                      let error_filter = error?.list_of_branches.filter(
                        (i) => item?.key !== i?.key
                      );

                      if (filter.length === 0) {
                        return;
                      }

                      // setError({ ...error, list_of_branches: error_filter });
                      setData({ ...data, list_of_branches: filter });
                    }}
                    disabled={data?.list_of_branches.length === 1}
                  >
                    <DeleteIcon
                      style={{ fontSize: "1.25rem", color: "#fb7d7f" }}
                    />
                  </IconButton>
                }
              >
                <div className="form_container" style={{ padding: "0" }}>
                  {/* <div className="grid_col2"> */}
                  <TextField
                    size="middle"
                    label="Branch name if different"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "list_of_branches",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                        type: "admin",
                      })
                    }
                    name="branch_name"
                    value={item?.branch_name}
                    // required={data?.is_ho_the_branch === false}
                    required={false}
                    error_state={error?.list_of_branches[index]?.branch_name}
                  />
                  {/* <TextField
                    size="middle"
                    label="Last name"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "list_of_branches",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="last_name"
                    value={item?.last_name}
                    required
                    error_state={error?.list_of_branches[index]?.last_name}
                  /> */}
                  {/* </div> */}
                  <TextField
                    size="middle"
                    label="Phone"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "list_of_branches",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        custom: "phone",
                        error: error,
                        setError: setError,
                        type: "admin",
                      })
                    }
                    name="phone"
                    value={item?.phone}
                    // required={data?.is_ho_the_branch === false}
                    required={false}
                    error_state={error?.list_of_branches[index]?.phone}
                    addonBefore={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          fontSize: ".875rem",
                          fontWeight: "600",
                        }}
                      >
                        <img
                          style={{ height: "0.75rem", opacity: "0.7" }}
                          src={canadaFlag}
                          alt=""
                        />
                        <span>+1</span>
                      </div>
                    }
                  />
                  <div className="grid_col2">
                    <TextField
                      label="Street Address"
                      name="address"
                      value={item?.address}
                      handleChange={(e) =>
                        subformInputChange({
                          value: e.target.value,
                          name: e.target.name,
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          type: "admin",
                        })
                      }
                      // required={data?.is_ho_the_branch === false}
                      required={false}
                      size="middle"
                      error_state={error?.list_of_branches[index]?.address}
                    />
                    <TextField
                      size="middle"
                      label="Address Line 2"
                      name="line2"
                      value={item?.line2}
                      handleChange={(e) =>
                        subformInputChange({
                          value: e.target.value,
                          name: e.target.name,
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          type: "admin",
                        })
                      }
                    />
                  </div>
                  <div className="grid_col2">
                    <Dropdown
                      size="middle"
                      label="Country"
                      options={[{ label: "Canada", value: "Canada" }]}
                      name="country"
                      value={item?.country}
                      handleChange={(value) =>
                        subformInputChange({
                          value: value,
                          name: "country",
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          type: "admin",
                        })
                      }
                      // required={data?.is_ho_the_branch === false}
                      required={false}
                      error_state={error?.list_of_branches[index]?.country}
                    />{" "}
                    <Dropdown
                      size="middle"
                      label="Province"
                      name="province"
                      value={item?.province}
                      options={PROVINCES_LIST}
                      handleChange={(value) =>
                        subformInputChange({
                          value: value,
                          name: "province",
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          type: "admin",
                        })
                      }
                      error_state={error?.list_of_branches[index]?.province}
                      // required={data?.is_ho_the_branch === false}
                      required={false}
                    />
                  </div>
                  <div className="grid_col2">
                    {/* <Dropdown
                      size="middle"
                      label="City"
                      name="city"
                      value={item?.city}
                      options={[{ label: "Toronto", value: "Toronto" }]}
                      handleChange={(value) =>
                        subformInputChange({
                          value: value,
                          name: "city",
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                        })
                      }
                      error_state={error?.list_of_branches[index]?.city}
                      required
                    /> */}
                    <TextField
                      size="middle"
                      label="City"
                      name="city"
                      value={item?.city}
                      handleChange={(e) =>
                        subformInputChange({
                          value: e.target.value,
                          name: e.target.name,
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          type: "admin",
                        })
                      }
                      error_state={error?.list_of_branches[index]?.city}
                      // required={data?.is_ho_the_branch === false}
                      required={false}
                    />
                    <TextField
                      size="middle"
                      label="Postal Code"
                      name="postal_code"
                      value={item?.postal_code}
                      handleChange={(e) =>
                        subformInputChange({
                          value: e.target.value,
                          name: e.target.name,
                          object_key: "list_of_branches",
                          key: item?.key,
                          data: data,
                          setData: setData,
                          error: error,
                          setError: setError,
                          custom: "postal_code",
                          type: "admin",
                        })
                      }
                      error_state={error?.list_of_branches[index]?.postal_code}
                      // required={data?.is_ho_the_branch === false}
                      required={false}
                    />
                  </div>
                </div>
              </Card>
            );
          })}
        </Flex>

        <div style={{ padding: "0 0 1rem" }}>
          <button className="next_btn subform_add_btn" onClick={addBranch}>
            Add branch
          </button>
        </div>
      </div>
    </div>
  );
};

export default Branch;
